module.exports = __webpack_public_path__ + "img/migu.e740755b.png";